var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-container"},[_c('div',{staticClass:"label"},[_c('h3',[_vm._v("Payment successful")]),_c('h4',[_vm._v(_vm._s(_vm.status))]),_c('button-input',{staticClass:"button-input",nativeOn:{"click":function($event){return _vm.ReturnToPage.apply(null, arguments)}}},[_vm._v(" Return to Finances Page ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }